import { ChangeDetectionStrategy, Component, HostBinding, Inject, Input, OnInit } from '@angular/core';

import { IBetslipMessages } from '../../../base/models/betslip-messages';
import { BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN, IBetslipMessagesProviderService } from '../../../base/services/betslip-messages-provider.service';

interface BarStyles {
    width?: string;
}

export interface IStakeProgressBarContext {
    start: number;
    end: number;
    fillPercentage: number;
    fillValue: number;
}

@Component({
    selector: 'bs-stake-progress-bar',
    templateUrl: './stake-progress-bar.component.html',
    styleUrls: ['./stake-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StakeProgressBarComponent implements OnInit {
    @Input() stakeProgressBarContext: IStakeProgressBarContext;
    @Input() currencySymbol: string;
    @HostBinding('class') className = 'stake-progress-bar';
    barStyle: BarStyles = {};
    messages: IBetslipMessages;

    constructor(@Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messagesProvider: IBetslipMessagesProviderService) {
        this.messages = messagesProvider.getMessages();
    }

    ngOnInit(): void {
        this.barStyle.width = `${this.stakeProgressBarContext.fillPercentage}%`;
    }
}
